import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import StoreStyle from '../../../assets/stylesheets/store/StorePage.module.css';
import StoreCardList from '../StoreCardList';

import Brioche from '../../../assets/img/sample/Pumpkin-Brioche.jpg';
import Chard from '../../../assets/img/sample/Chard.jpg';
import DelicataSquash from '../../../assets/img/sample/Delicata Squash.jpg';
import Kielbasa from '../../../assets/img/sample/Smoked Kielbasa.jpg';
import Cranberry from '../../../assets/img/sample/Cranberry.jpg';
import SyrupsHoney from '../../../assets/img/sample/Syrups-Honey.jpg';

const NEW_ITEMS = [
  { id: 'new-1', name: 'Pumpkin Brioche',          price: '$6.95',        info: 'Freshly baked • Seasonal',           img: Brioche },
  { id: 'new-2', name: 'Rainbow Swiss Chard',      price: '$2.99/bunch',  info: 'New harvest • Color mix',            img: Chard },
  { id: 'new-3', name: 'Delicata Squash',          price: '$1.99/lb',     info: 'First harvest • Tender & sweet',     img: DelicataSquash },
  { id: 'new-4', name: 'Smoked Kielbasa',          price: '$9.99',        info: 'Small-batch • Hardwood smoked',      img: Kielbasa },
  { id: 'new-5', name: 'Fresh Cranberries (Local)',price: '$3.99/12oz',   info: 'New arrival • Tart & vibrant',       img: Cranberry },
  { id: 'new-6', name: 'Raw Wildflower Honey',     price: '$8.99',        info: 'Fall harvest • Unfiltered',          img: SyrupsHoney },
];

export default function NewThisWeek({ title = 'New items', to }) {
  const LIMIT = 6;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 300);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className={StoreStyle['featured-section']}>
      <div className={StoreStyle['featured-header']}>
        <h2 style={{ fontSize: 22, margin: 0 }}>{title}</h2>
        {to ? <Link to={to} style={{ color: '#16a34a', fontWeight: 600 }}>See all</Link> : null}
      </div>

      <div className={StoreStyle['swiper-rail']}>
        <StoreCardList
          items={NEW_ITEMS}
          loading={loading}
          onBuy={(item) => console.log('Buy clicked:', item)}
          skeletonCount={LIMIT}
        />
      </div>
    </section>
  );
}